import { render, staticRenderFns } from "./Condicionalidade.vue?vue&type=template&id=fa5aaf02"
import script from "./Condicionalidade.vue?vue&type=script&lang=js"
export * from "./Condicionalidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports